import { ApplicationRef, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { concat, interval, Subscription } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';

import { UserModel } from './models/user.model';
import { ValBrowserStorageService } from './services/val-browser-storage.service';
import { ValStorageService } from './services/val-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'valfresco b2b';
  private _sub: Subscription;
  private _sub1: Subscription;
  private _sub2: Subscription;
  public dropDownVisible = false;
  public user: UserModel;
  public isToggled = true;
  public searchString: string;
  constructor(
    private _r: Router,
    public st: ValStorageService,
    private _bs: ValBrowserStorageService,
    private _ar: ActivatedRoute,
    private _swUpdate: SwUpdate,
    private _appRef: ApplicationRef,
    private _cdr: ChangeDetectorRef
  ) { }
  ngOnDestroy(): void {
    this._sub.unsubscribe();
    if (this._sub1) {
      this._sub1.unsubscribe();
    }
    if (this._sub2) {
      this._sub2.unsubscribe();
    }
  }
  ngOnInit(): void {
    if (this._swUpdate.isEnabled) {
      const appIsStable$ = this._appRef.isStable.pipe(first(isStable => isStable === true));
      const everyMinute$ = interval(60 * 1000);
      const everyMinuteOnceAppIsStable$ = concat(appIsStable$, everyMinute$);
      this._sub1 = everyMinuteOnceAppIsStable$.pipe(tap(_x => {
        this._swUpdate.checkForUpdate();
      })).subscribe();

      this._sub2 = this._swUpdate.versionUpdates.pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
        tap(evt => {
          if (confirm("New application version is available. Load New Version?")) {
            this._swUpdate.activateUpdate().then(() => document.location.reload());
            // window.location.reload();
          }
        })).subscribe();
    }
    this.user = this._bs.getCurrentUser();

    this._sub = this._bs.currentUser.pipe(tap(x => {
      this.user = x;
      this._cdr.detectChanges();
    })).subscribe();
  }
  public toggle = () => {
  }
  public logoff = () => {
    this._bs.logOut();
    this._r.navigate(['login'], { relativeTo: this._ar });
  }
  public search = () => {
    this.searchString = this.searchString ? this.searchString.trim() : null;
    this.searchString = this.searchString && this.searchString.length < 1 ? null : this.searchString;
    if (this.searchString) {
      this.st.searchEvent.emit(this.searchString);
    }
  }
}
